///jacques-andre-editeur\proshop-v2\frontend\src\index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/jaeStyle.css';
import './assets/styles/aLaUne.css';
import "react-quill/dist/quill.snow.css";

import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from './screens/HomeScreen'; 
import SearchScreen from './screens/SearchScreen'; 
import BooksScreen from './screens/BooksScreen';
import BookScreen from './screens/BookScreen';
import AuthorsScreen from './screens/AuthorsScreen';
import AuthorScreen from './screens/AuthorScreen';
import BooksCollectionsScreen from './screens/BooksCollectionsScreen';
import BooksCollectionScreen from './screens/BooksCollectionScreen';
import NewsScreen from './screens/NewsScreen';
import ContactsScreen from './screens/ContactsScreen';
import PanierScreen from './screens/PanierScreen';
import LoginScreen from './screens/LoginScreen';
// import RegisterScreen from './screens/RegisterScreen';
import ShippingScreen from './screens/ShippingScreen';
//import PaymentScreen from './screens/PaymentScreen';
//import PlaceOrderScreen from './screens/PlaceOrderScreen';
//import OrderScreen from './screens/OrderScreen';
//import ProfileScreen from './screens/ProfileScreen';

import OrderListScreen from './screens/admin/OrderListScreen';
import OrderByIdScreen from './screens/admin/OrderByIdScreen';
import BookListScreen from './screens/admin/BookListScreen';
import BookEditScreen from './screens/admin/BookEditScreen';
import BookAddScreen from './screens/admin/BookAddScreen';
import AuthorAddScreen from './screens/admin/AuthorAddScreen';
import AuthorListScreen from './screens/admin/AuthorListScreen';
import AuthorEditScreen from './screens/admin/AuthorEditScreen';
// import AlauneHandleScreen from './screens/admin/AlauneHandleScreen';
import AdminHomeScreen from './screens/admin/AdminHomeScreen';
import BooksCollectionAddScreen from './screens/admin/BooksCollectionAddScreen';
import BooksCollectionListScreen from './screens/admin/BooksCollectionListScreen';
import BooksCollectionEditScreen from './screens/admin/BooksCollectionEditScreen';
import NewsAddScreen from './screens/admin/NewsAddScreen';
import NewsListScreen from './screens/admin/NewsListScreen';
import NewsEditScreen from './screens/admin/NewsEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import store from './store';
import { Provider } from 'react-redux';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index={true} path='/' element={<HomeScreen />} />
      <Route path='/page/:pageNumber' element={<HomeScreen />} />
      <Route path='/recherche/:keyword' element={<SearchScreen />} />
      <Route path='/recherche/:keyword/page/:pageNumber' element={<SearchScreen />} />
      <Route path='/livres' element={<BooksScreen />} />
      <Route path='/livres/page/:pageNumber' element={<BooksScreen />} />
      {/* <Route path='/livre/:id' element={<BookScreen />} /> */}
      <Route path='/livre/:slug' element={<BookScreen />} />
      <Route path='/auteurs' element={<AuthorsScreen />} />
      <Route path='/auteurs/page/:pageNumber' element={<AuthorsScreen />} />
      <Route path='/auteurs/:keyword/page/:pageNumber' element={<AuthorsScreen />} />
      {/* <Route path='/auteur/:id' element={<AuthorScreen />} /> */}
      {/* <Route path="/auteur/:slug" element={<AuthorProfile />} /> */}
      <Route path="/auteur/:slug" element={<AuthorScreen />} />
      <Route path='/collections' element={<BooksCollectionsScreen />} />
      <Route path='/collections/page/:pageNumber' element={<BooksCollectionsScreen />} />
      {/* <Route path='/collection/:id' element={<BooksCollectionScreen />} /> */}
      <Route path='/collection/:slug' element={<BooksCollectionScreen />} />
      <Route path='/actualites' element={<NewsScreen />} />
      <Route path='/contacts' element={<ContactsScreen />} />
      <Route path='/panier' element={<PanierScreen />} />
      <Route path='/shipping' element={<ShippingScreen />} />
      <Route path='/login' element={<LoginScreen />} />
      {/* <Route path='/register' element={<RegisterScreen />} /> */}
      {/* Registered users */}
      {/* <Route path='' element={<PrivateRoute />}>
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
      </Route> */}
      {/* Admin users */}
      <Route path='' element={<AdminRoute />}>
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/order/:id' element={<OrderByIdScreen />} />
        <Route path='/admin/booklist' element={<BookListScreen />} />
        <Route path='/admin/booklist/:pageNumber' element={<BookListScreen />} />
        <Route path='/admin/book/:id/edit' element={<BookEditScreen />} />
        <Route path='/admin/bookadd' element={<BookAddScreen />} />
        
        <Route path='/admin/authorlist' element={<AuthorListScreen />} />
        <Route path='/admin/authorlist/:pageNumber' element={<AuthorListScreen />} />
        <Route path='/admin/author/:id/edit' element={<AuthorEditScreen />} /> 
        {/* <Route path='/admin/alaune' element={<AlauneHandleScreen />} />  */}
        <Route path='/admin' element={<AdminHomeScreen />} /> 
        <Route path='/admin/authoradd' element={<AuthorAddScreen />} />
        
        <Route path='/admin/bookscollectionlist' element={<BooksCollectionListScreen />} />
        <Route path='/admin/bookscollectionlist/:pageNumber' element={<BooksCollectionListScreen />} />
        <Route path='/admin/bookscollection/:id/edit' element={<BooksCollectionEditScreen />} />
        <Route path='/admin/bookscollectionadd' element={<BooksCollectionAddScreen />} />
        
        <Route path='/admin/newslist' element={<NewsListScreen />} />
        <Route path='/admin/newslist/:pageNumber' element={<NewsListScreen />} />
        <Route path='/admin/news/:id/edit' element={<NewsEditScreen />} /> 
        <Route path='/admin/newsadd' element={<NewsAddScreen />} />
        
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
      </Route>
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <Elements stripe={stripePromise}>
          <RouterProvider router={router} />
        </Elements>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
